import { Alert } from 'antd';
import { useEffect, useRef, useState } from 'react';

export const useTour = (isAdmin, flag = false) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [allowNextStep, setAllowNextStep] = useState(false);

  const generateIdRef = useRef(null);
  const modalRef = useRef(null);
  const licenseRef = useRef(null);
  const changeUserRef = useRef(null);
  const editOtherRef = useRef(null);
  const actionsRef = useRef(null);
  const searchRef = useRef(null);

  useEffect(() => {
    setAllowNextStep(flag);
  }, [flag]);

  const steps = [
    {
      title: 'Страница устройств',
      description:
        'Добро пожаловать в Список устройств — центр, где вы управляете всеми подключёнными устройствами. Быстро находите, редактируете и контролируете доступ, обеспечивая слаженную работу информационного контура. Всё, что нужно для эффективной и надёжной работы, доступно в один клик.',
      target: null,
    },
    {
      title: 'Регистрация устройств',
      description: 'Зарегистрируйте новое устройство в системе — всего пара шагов, и устройство будет готово к работе.',
      target: () => generateIdRef.current,
    },
    {
      title: 'Правила заполнения',
      description: (
        <>
          <p>
            Заполните все обязательные поля, выберите тип устройства и срок действия лицензии. Если не выберете
            ответственного — им автоматически станете вы. После заполнения нажмите ОК для регистрации устройства.
          </p>
          {!allowNextStep && (
            <Alert message={'Чтобы продолжить тур зарегистрируйте устройство!'} style={{ marginTop: '10px' }} />
          )}
        </>
      ),
      target: generateIdRef.current,
    },
    isAdmin
      ? {
          title: 'Редактирование лицензий',
          description:
            'Если срок действия лицензии истёк или скоро истекает, вы можете продлить её — выберите новую дату в календаре и подтвердите изменения. В противном случае продление не требуется.',
          target: () => licenseRef.current,
        }
      : null,
    {
      title: 'Смена ответственного пользователя',
      description:
        'Смените ответственного пользователя — выберите нового из списка и подтвердите. После этого устройство будет доступно в профиле выбранного ответственного.',
      target: () => changeUserRef.current,
    },
    {
      title: 'Редактирование других данных',
      description: 'Нажмите, чтобы отредактировать данные владельца устройства прямо из таблицы.',
      target: () => editOtherRef.current,
    },
    {
      title: 'Действия',
      description: 'Оперативное управление устройством — откройте список доступных команд.',
      target: () => actionsRef.current,
    },
    {
      title: 'Поиск',
      description: 'Используйте поиск для быстрого нахождения устройства по ID или позывному.',
      target: () => searchRef.current,
    },
  ].filter(item => item);

  const startTour = () => {
    setCurrentStep(0);
    setIsTourOpen(true);
  };

  const handleTourChange = nextStep => {
    if (!allowNextStep && currentStep === 2) {
      return;
    }

    setCurrentStep(nextStep);
  };

  const handleClose = () => {
    setIsTourOpen(false);
  };

  return {
    generateIdRef,
    modalRef,
    licenseRef,
    changeUserRef,
    editOtherRef,
    actionsRef,
    searchRef,
    steps,
    startTour,
    handleTourChange,
    handleClose,
    isTourOpen,
    currentStep,
  };
};
